import React from 'react';
import SearchMapDesktop from './SearchMapDesktop';

// const SearchMapMobileWrapped = loadable(() => import('./SearchMapMobile'));

const SearchMapSplitter = (props) => {
    const { ...mapProps } = props;

    let nonInteractiveMobileSpacing = 'eds-l-pad-bot-6';

    nonInteractiveMobileSpacing = '';

    const MapToShow = SearchMapDesktop;

    // if (props.isMobile) {
    //     MapToShow = SearchMapMobileWrapped;
    // }

    return (
        <div className={nonInteractiveMobileSpacing}>
            <MapToShow {...mapProps} />
        </div>
    );
};

export default SearchMapSplitter;
